<template>
  <div class="videoKan_phone">
    <div class="container">
      <!-- logo start -->
      <div class="logo">
        <img src="/statics/image/phone/logo.png" class="thumb" alt />
      </div>
      <!-- logo end -->
      <!-- menu start -->
      <div class="menu flex">
        <div class="item cur" @click="toPage(-1,-1)">首页</div>
        <div class="item" @click="toPage(11,indexa)">新区概况</div>
        <div class="item" @click="toPage(12,indexb)">新区要闻</div>
        <div class="item" @click="toPage(13,indexc)">招商引资</div>
      </div>
      <!-- menu end -->
      <!-- content start -->

      <div class="content">
        <!-- swiper start -->

        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item,index) in xinqulist.lunbolist"
              :key="index"
              @click="toPlay(item.video_id)"
            >
              <div class="pic">
                <img :src="adddom(item.thumb_image?item.thumb_image:'')" alt="pic" />
                <span class="title">{{item.title}}</span>
              </div>
            </div>
          </div>
          <!-- 导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
        <!-- swiper end -->
        <!-- vpg 视频组 start -->
        <div class="vpg flex-between">
          <div
            class="item"
            v-for="(item,index) in xinqulist.recomlist"
            :key="index"
            @click="toPlay(item.video_id)"
          >
            <img :src="adddom(item.thumb_image?item.thumb_image:'')" alt class="thumb" />
            <div class="long">{{item.video_length}}</div>
            <div class="text text-ellipsis">{{item.title}}</div>
          </div>
        </div>
        <!-- vpg 视频组 end -->
        <!-- 热点 start -->
        <div class="floor">
          <div class="title-group flex-between">
            <div class="title">时下热点</div>
          </div>
          <div class="video-group flex-between">
            <div
              class="item"
              v-for="(item,index) in xinqulist.hotlist"
              :key="index"
              @click="toPlay(item.video_id)"
            >
              <div class="cover-group">
                <img :src="adddom(item.thumb_image?item.thumb_image:'')" class="thumb" alt />
                <div class="long">{{item.video_length}}</div>
              </div>
              <div class="info">
                <div class="name text-ellipsis">{{item.title}}</div>
                <div class="ms flex">
                  <div class="text flex">
                    <img src="/statics/image/phone/see.png" class="icon" alt />
                    <span>{{item.count}}</span>
                  </div>
                  <!-- <div class="text flex">
                    <img src="/statics/image/phone/message.png" class="icon" alt />
                    <span>0</span>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 热点 end -->
        <!-- 最新视频 start -->
        <div class="floor">
          <div class="title-group flex-between">
            <div class="title">最新视频</div>
            <div class="more flex" @click="tomore">
              更多
              <img src="/statics/image/phone/arrow_right.png" class="arrow" alt />
            </div>
          </div>
          <div class="video-group flex-between">
            <div
              class="item"
              v-for="(item,index) in xinqulist.newlist"
              :key="index"
              @click="toPlay(item.video_id)"
            >
              <div class="cover-group">
                <img :src="adddom(item.thumb_image?item.thumb_image:'')" class="thumb" alt />
                <div class="long">{{item.video_length}}</div>
              </div>
              <div class="info">
                <div class="name text-ellipsis">{{item.title}}</div>
                <div class="ms flex">
                  <div class="text flex">
                    <img src="/statics/image/phone/see.png" class="icon" alt />
                    <span>{{item.count}}</span>
                  </div>
                  <!-- <div class="text flex">
                    <img src="/statics/image/phone/message.png" class="icon" alt />
                    <span>0</span>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 更多精彩 end -->
        <!-- 最新视频 start -->
        <div class="floor">
          <div class="title-group flex-between">
            <div class="title">更多精彩</div>
          </div>
          <div class="big-card" @click="toPlay(xinqulist.otherlist[0].video_id)">
            <img
              :src="adddom(xinqulist.otherlist[0]&&xinqulist.otherlist[0].thumb_image?xinqulist.otherlist[0].thumb_image:'')"
              class="thumb"
              alt
            />
          </div>
          <div class="video-groupA">
            <div
              class="item flex"
              v-for="(item,index) in xinqulist.otherlist.slice(1)"
              :key="index"
              @click="toPlay(item.video_id)"
            >
              <img :src="adddom(item.thumb_image?item.thumb_image:'')" class="thumb" alt />
              <div class="info">
                <div class="name multi-ellipsis">{{item.title}}</div>
                <div class="ds flex">
                  <div class="date">{{item.publish_at}}</div>
                  <!-- <div class="text flex">
                    <img src="/statics/image/phone/message.png" class="icon" alt />
                    <span>0</span>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 最新视频 end -->
      </div>

      <!-- content end -->
      <!-- footer start -->
      <div class="footer">
        <p>主办：河北衡水高新技术产业开发区</p>
        <p>网站标识：1311000037</p>
        <p>公安备案：13110802000107</p>
        <p>地址：衡水市永兴西路1988号</p>
        <a href="http://beian.miit.gov.cn/" class="map">冀ICP备16022288号-1 网站地图</a>
        <p>技术支持：河北中信联信息技术有限公司</p>
        <img src="/statics/image/phone/gov.png" class="gov" alt />
      </div>
      <!-- footer end -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xinqulist: {
        lunbolist: [],
        recomlist: [],
        hotlist: [],
        newlist: [],
        otherlist: []
      },
      catelist: [],
      indexa: "",
      indexb: "",
      indexc: ""
    };
  },
  created() {
    // this.cateId = this.$route.query.cate_id;
    // console.log("111");
    function mobileskip() {
      var mobileAgent = new Array(
        "iphone",
        "ipod",
        "ipad",
        "android",
        "mobile",
        "blackberry",
        "webos",
        "incognito",
        "webmate",
        "bada",
        "nokia",
        "lg",
        "ucweb",
        "skyfire"
      );
      var browser = navigator.userAgent.toLowerCase();
      var isMobile = false; //记录是否移动端
      for (var i = 0; i < mobileAgent.length; i++) {
        if (browser.indexOf(mobileAgent[i]) != -1) {
          isMobile = true;
          break;
        }
      }
      return isMobile;
    }
    if (mobileskip()) {
      this.getVideo();
      this.getNav();
      // console.log("222");
      // 移动端
    } else {
      this.$router.push({
        path: "/videoKan"
      });
    }
  },
  methods: {
    toPath(url, obj) {
      if (this.$route.fullPath == url) {
        return;
      }
      if (this.$route.path == url) {
        this.$router.push({
          path: url,
          query: obj
        });
        return;
      }
      this.$router.push({
        path: url,
        query: obj
      });
    },
    toPage(id, index) {
      if (id == "-1") {
        this.toPath("/", {});
      } else {
        this.toPath("/xqNews", { id: id, index: index });
      }
    },
    getNav() {
      var that = this;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          that.catelist = res.result.all_cate;
          for (var i in that.catelist) {
            if (that.catelist[i].id == "11") {
              that.indexa = i;
            } else if (that.catelist[i].id == "12") {
              that.indexb = i;
            } else if (that.catelist[i].id == "13") {
              that.indexc = i;
            }
          }
          // console.log(that.indexa,that.indexb,that.indexc);
        }
      });
    },
    //   点击最新视频更多
    tomore() {
      this.$router.push({
        path: "/videoPhone",
        query: {
          cate_id: 1
        }
      });
    },
    toPlay(id) {
      this.$router.push({
        path: "/videoPlayPhone",
        query: {
          id: id
        }
      });
    },
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    getVideo() {
      var that = this;
      that.$api.index.xinqulist({}).then(function(res) {
        if (res.code == 200) {
          that.xinqulist = res.result;
        }
      });
    }
  },
  mounted() {},
  updated() {
    setTimeout(function() {
      var mySwiper = new Swiper(".mySwiper", {
        loop: true, // 循环模式选项
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        // 前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    }, 100);
  }
};
</script>

<style lang="scss" scoped>
.swiper {
  width: 100%;
  height: 5.4rem;
  position: relative;
  overflow: hidden;
  border-radius: 0.2rem;
}
.swiper .pic {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper .pic img {
  width: 100%;
  height: 100%;
}
.swiper .pic .title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: block;
  text-align: center;
  color: #fff;
  background-color: #5b6b7c;
  line-height: 0.6rem;
}
.swiper-button-next,
.swiper-button-prev {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #5b6b7c;
  color: #fff;
  border-radius: 50%;
}
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  font-size: 0.1rem;
}
.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  font-size: 0.1rem;
}
.swiper-button-next {
  right: 0.2rem;
  //   border-radius: 0.1rem 0 0 0.1rem;
}

.swiper-button-prev {
  left: 0.2rem;
  //   border-radius: 0 0.1rem 0.1rem 0;
}
</style>